import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class OTMReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otmReportData: {},
            downloadReportName: 'OTM Report',
            firstOTMDate: '',
            lastOTMDate: '',
        };
        this.download = this.download.bind(this);
        this.buildCsvData = this.buildCsvData.bind(this);
        this.getOTMReportData = this.getOTMReportData.bind(this);
        this.pusherChannel = Echo.channel('job-otm-updates').listen(
            'JobOTMReportDataUpdated',
            async () => {
                await this.getOTMReportData();
            }
        );
    }

    componentWillUnmount() {
        this.pusherChannel?.stopListening('JobOTMReportDataUpdated');
        Echo.leaveChannel('job-otm-updates');
    }

    componentDidMount() {
        if (!_.isEmpty(window.otmReportData)) {
            const dateKeys = _.sortBy(Object.keys(window.otmReportData), date => new Date(date));
            this.setState({
                otmReportData: window.otmReportData,
                firstOTMDate: _.first(dateKeys) || '',
                lastOTMDate: _.last(dateKeys) || '',
            });
        }
    }

    async getOTMReportData() {
        try {
            const response = await fetch('/api/v1/portal/planning/otm-report', {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    "Authorization": `Bearer ${window.api_token}`,
                    "Accept": 'application/json'
                }
            });

            if (!response.ok) throw new Error('Failed to fetch OTM report data');

            const data = _.get(await response.json(), 'otm-report-data', {});
            if (!_.isEmpty(data)) {
                const dateKeys = _.sortBy(Object.keys(data), date => new Date(date));
                this.setState({
                    otmReportData: data,
                    firstOTMDate: _.first(dateKeys) || '',
                    lastOTMDate: _.last(dateKeys) || '',
                });
                window.otmReportData = data;
            }
        } catch (error) {
            console.error('Error fetching OTM report data:', error);
        }
    }
    download(filename, csvData) {
        if (!csvData) return;

        filename = `${filename} From ${moment(this.state.firstOTMDate || new Date()).format("YYYY-MM-DD")} To ${moment(this.state.lastOTMDate || new Date()).format("YYYY-MM-DD")}.csv`;
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData));
        element.setAttribute('download', filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    buildCsvData() {
        const { otmReportData } = this.state;
        if (!otmReportData || Object.keys(otmReportData).length === 0) return '';

        let csv = "JOB NUMBER,COMPANY,REQUIRED PICKUP,REQUIRED DROPOFF,REG,CUSTOMER,PICKUP TOWN/CITY,PICKUP POSTCODE,DROPOFF TOWN/CITY,DROPOFF POSTCODE,DRIVER,SELECTED COMPANY,PRIORITY,ZONE\n";
        const dateKeys = Object.keys(otmReportData).sort((a, b) => new Date(a) - new Date(b));

        const companyLabels = {
            '1': 'ACV', '2': 'SCCD', '3': 'CND', '4': 'BVL', '5': 'G4', '6': 'TLC', '7': 'ACV TRUCK'
        };
        const companyMapping = {
            acv: "ACV",
            cnd: "CND",
            bvl: "BVL",
            sccd: "SCCD",
            g4: "G4",
            tlc: "Test Logistics Company",
            "acv-truck": "ACV Truck"
        };
        const priorityMapping = {
            available: "Available",
            priority: "Priority",
        };
        dateKeys.forEach(dateKey => {
            if (!otmReportData[dateKey]) return;
            csv += `"${moment(dateKey).format('DD/MM/YYYY')}"\n`;

            otmReportData[dateKey].forEach(job => {
                if (!job) return;

                // const selectedCompany = companyLabels[job.company_id?.toString()] ?? job.company_name ?? 'Unknown';
                const selectedCompany = job?.selected_company ? (companyMapping[job.selected_company] || '-') : '-';
                const priority = job?.quick_prioritise ? (priorityMapping[job.quick_prioritise] || '-') : '-';
                const row = [
                    job.id ?? '',
                    job.company_name ?? '',
                    `${job.pickup_day ?? ''}/${job.pickup_month ?? ''}/${job.pickup_year ?? ''} ${job.pickup_time ?? ''}`,
                    `${job.dropoff_day ?? ''}/${job.dropoff_month ?? ''}/${job.dropoff_year ?? ''} ${job.dropoff_time ?? ''}`,
                    job.registration_number ?? '',
                    job.customer_name ?? '',
                    job.pickup_town_city ?? '',
                    job.pickup_postcode ?? '',
                    job.dropoff_town_city ?? '',
                    job.dropoff_postcode ?? '',
                    job.driver_name ?? '-',
                    selectedCompany,
                    priority,
                    job.zone_name ?? '-',
                ];
                csv += row.map(field => `"${field}"`).join(",") + "\n";
            });
        });

        return csv;
    }
    render() {
        const { otmReportData, downloadReportName } = this.state;

        const dateKeys = otmReportData && typeof otmReportData === "object"
            ? Object.keys(otmReportData).sort((a, b) => new Date(a) - new Date(b))
            : [];

        const totalRows = dateKeys.length > 0
            ? Object.values(otmReportData).reduce((total, jobs) => total + (Array.isArray(jobs) ? jobs.length : 0), 0)
            : 0;

        const downloadableCsvDataOTM = this.buildCsvData();
        const companyMapping = {
            acv: "ACV",
            cnd: "CND",
            bvl: "BVL",
            sccd: "SCCD",
            g4: "G4",
            tlc: "Test Logistics Company",
            "acv-truck": "ACV Truck"
        };
        const priorityMapping = {
            available: "Available",
            priority: "Priority",
        };
        return (
            <div className="container-fluid otm">
                <div className="otm-header-container">
                    <h2 className="mb-0">OTM Report</h2>
                    {/* {dateKeys.length > 0 && (
                        <button
                            className="btn btn-primary btn-lg ml-auto"
                            onClick={() => this.download(downloadReportName || 'OTM_Report', downloadableCsvDataOTM)}
                        >
                            <i className="fa fa-download"></i> Download
                        </button>
                    )} */}
                </div>

                <div className="row mt-3">
                    <div className="col-md-3">
                        <label className="alert alert-primary mb-0">
                            <b>{totalRows} Report data(s) found..</b>
                        </label>
                    </div>
                </div>

                {dateKeys.length > 0 ? (
                    <>
                        <div className="row mt-5 otm">
                            <div className="col-md-12">
                                <div className="otm-report-tbl-scroll">
                                    <table className="otm-report-tbl no-footer table table-bordered">
                                        <thead className="sticky-top-without-zindex bg-light">
                                            <tr>
                                                <th>Job Number</th>
                                                <th>Company</th>
                                                <th>Required Pickup</th>
                                                <th>Required Dropoff</th>
                                                <th>Reg</th>
                                                <th>Customer</th>
                                                <th>Pickup Town/City</th>
                                                <th>Pickup Postcode</th>
                                                <th>Dropoff Town/City</th>
                                                <th>Dropoff Postcode</th>
                                                <th>Driver</th>
                                                <th>Selected Company</th>
                                                <th>Prioritise</th>
                                                <th>Zone</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dateKeys.map((dateKey) => (
                                                <React.Fragment key={dateKey}>
                                                    <tr className="date-header">
                                                        <td colSpan="14" className="text-left text-white otm-report-header-date">
                                                            {dateKey ? moment(dateKey).format('DD/MM/YYYY') : 'Invalid Date'}
                                                        </td>
                                                    </tr>
                                                    {Array.isArray(otmReportData[dateKey]) &&
                                                        otmReportData[dateKey].map((job, idx) =>
                                                            job && typeof job === 'object' ? (
                                                                <tr key={idx} id={`otmReportData_${job?.id || idx}`}>
                                                                    <td className="job-ref-font16">
                                                                        {job?.id ? (
                                                                            <a href={`/jobs/view/${job.id}`} target="_blank" rel="noopener noreferrer">
                                                                                {job.id}
                                                                            </a>
                                                                        ) : (
                                                                            '-'
                                                                        )}
                                                                    </td>
                                                                    <td>{job?.company_name || '-'}</td>
                                                                    <td>
                                                                        {job?.pickup_day && job?.pickup_month && job?.pickup_year && job?.pickup_time
                                                                            ? `${job.pickup_day}/${job.pickup_month}/${job.pickup_year} ${job.pickup_time}`
                                                                            : '-'}
                                                                    </td>
                                                                    <td>
                                                                        {job?.dropoff_day && job?.dropoff_month && job?.dropoff_year && job?.dropoff_time
                                                                            ? `${job.dropoff_day}/${job.dropoff_month}/${job.dropoff_year} ${job.dropoff_time}`
                                                                            : '-'}
                                                                    </td>
                                                                    <td>{job?.registration_number || '-'}</td>
                                                                    <td>{job?.customer_name || '-'}</td>
                                                                    <td>{job?.pickup_town_city || '-'}</td>
                                                                    <td>{job?.pickup_postcode || '-'}</td>
                                                                    <td>{job?.dropoff_town_city || '-'}</td>
                                                                    <td>{job?.dropoff_postcode || '-'}</td>
                                                                    <td>{job?.driver_name || '-'}</td>
                                                                    <td>{job?.selected_company ? companyMapping[job.selected_company] || '-' : '-'}</td>
                                                                    <td>{job?.quick_prioritise ? priorityMapping[job.quick_prioritise] || '-' : '-'}</td>
                                                                    <td>{job?.zone_name || '-'}</td>
                                                                </tr>
                                                            ) : null
                                                        )}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <table className="otm-report-tbl no-footer table table-bordered no-records">
                        <thead className="sticky-top-without-zindex bg-light">
                            <tr>
                                <th>Job Number</th>
                                <th>Company</th>
                                <th>Required Pickup</th>
                                <th>Required Dropoff</th>
                                <th>Reg</th>
                                <th>Customer</th>
                                <th>Pickup Town/City</th>
                                <th>Pickup Postcode</th>
                                <th>Dropoff Town/City</th>
                                <th>Dropoff Postcode</th>
                                <th>Driver</th>
                                <th>Selected Company</th>
                                <th>Prioritise</th>
                                <th>Zone</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key="no-records">
                                <td colSpan="14" className="text-center otm-report-no-record-found">NO RECORDS</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
        );

    }

}
OTMReport.propTypes = {
    message_if_none: PropTypes.string
};

if (document.getElementById('react-component-g4-logistics-portal-otm_report')) {
    ReactDOM.render(
        <OTMReport message_if_none="Nothing to report on." />,
        document.getElementById('react-component-g4-logistics-portal-otm_report')
    );
}
